import React, { useState } from 'react';
import './Doublestationextrusion.css';
import Extrusionblow1 from '../../../imgs/Extrusionblow1.webp';
import Extrusionblow2 from '../../../imgs/Extrusionblow2.webp';
import Extrusionblow3 from '../../../imgs/Extrusionblow3.webp';
import Extrusionblow4 from '../../../imgs/Extrusionblow4.webp';

const images = [
    { src: Extrusionblow1 },
    { src: Extrusionblow2 },
    { src: Extrusionblow3 },
    { src: Extrusionblow4 },
];

const Doublestationextrusion = () => {
    const [current, setCurrent] = useState(0);

    const nextSlide = () => {
        setCurrent((current + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrent((current - 1 + images.length) % images.length);
    };

    const goToSlide = (index) => {
        setCurrent(index);
    };

    return (
        <div className="Extrusionblow-main-container">

            <div className="Extrusionblow-slideshow">
                {images.map((img, index) => (
                    <div className={index === current ? "mySlides active" : "mySlides"} key={index}>
                        {index === current && (
                            <>
                                <img src={img.src} alt={`Slide ${index + 1}`} className="slide-image" />
                            </>
                        )}
                    </div>
                ))}
                <a className="prev" onClick={prevSlide}>&#10094;</a>
                <a className="next" onClick={nextSlide}>&#10095;</a>

                <div className="dots">
                    {images.map((_, index) => (
                        <span
                            key={index}
                            className={index === current ? "dot active" : "dot"}
                            onClick={() => goToSlide(index)}
                        ></span>
                    ))}
                </div>
            </div>

            <div className="Extrusionblow-text">
                <h2>High Speed Double Station Extrusion Blow Molding Machine</h2>
                <h3>EB SERIES</h3>
                <p>
                    Dishatech  Double Station Extrusion Blow Molding Machine EB30U/EB70U is specialized for manufacturing bottles and containers which under 10L. </p>
                <ul>
                    <li><strong>Max Bottle Capacity:</strong> –  10(L)</li>
                    <li><strong>Clamping Force:</strong> –  65~110(KN)</li>
                    <li><strong>Extrusion Weight(HDPE) :</strong> –  35~125(kg/hr)</li>

                    <li><strong>Applications :</strong> -Wide Range Of Bottles For Food & Non-Food</li>
                </ul>
                <button className="price-btn1">Get Machine Price</button>
            </div>
        </div>
    );
};
export default Doublestationextrusion;
